import debounce from "lodash.debounce"
const delay = 300
export const NewsTab = {
  mounted() {
    this.debouncedMarkAsRead = debounce(() => this.markAsRead(), delay)

    this.el.addEventListener("click", (event) => {
      if (event.target.closest("form")) return
      this.debouncedMarkAsRead()
    })

    this.el
      .querySelector(".information-tab-scroll-target")
      .addEventListener("scroll", this.debouncedMarkAsRead)
  },

  destroyed() {
    // Otherwise pushEventTo may be sent to the LiveView
    // See https://github.com/phoenixframework/phoenix_live_view/issues/4066
    this.debouncedMarkAsRead.cancel()
  },

  markAsRead() {
    this.pushEventTo(this.el, "markAsRead", {})
  },
}
